import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../pages-styles/project-consultancy.css';

// Simple advisory page with illustration and 3D card motion
export default function Advisory() {
  useEffect(() => {
    // subtle entrance for the 3D card
    const el = document.querySelector('.advisory-3d-card');
    if (el) el.classList.add('enter');
  }, []);

  return (
    <div className="project-consultancy">
      <section className="consultancy-hero-banner advisory-hero">
        <div className="consultancy-hero-overlay"></div>
        <div className="consultancy-hero-content">
          <div className="consultancy-hero-text">
            <h1>Project Consultancy & Advisory</h1>
            <p>
              Strategic advisory to turn ideas into deliverable projects — from feasibility and planning to
              technical coordination and stakeholder engagement. We combine research, commercial sense and
              technical know-how to help projects succeed.
            </p>
          </div>

          <div className="advisory-illustration">
            <div className="advisory-3d-scene">
              <div className="advisory-3d-card">
                <div className="face front">
                  <svg width="220" height="220" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="g1" x1="0" x2="1">
                        <stop offset="0%" stopColor="#16c784" />
                        <stop offset="100%" stopColor="#00d4ff" />
                      </linearGradient>
                    </defs>
                    <rect x="10" y="10" width="200" height="200" rx="16" fill="url(#g1)" opacity="0.12" />
                    <g transform="translate(40,40) scale(0.9)">
                      <circle cx="50" cy="30" r="18" fill="#fff" opacity="0.14" />
                      <rect x="10" y="70" width="80" height="10" rx="4" fill="#fff" opacity="0.12" />
                      <rect x="10" y="90" width="60" height="8" rx="4" fill="#fff" opacity="0.1" />
                    </g>
                  </svg>
                  <div className="card-label">Advisory Snapshot</div>
                </div>
                <div className="face back">
                  <h4>Outcome Focus</h4>
                  <p>Feasibility reports, roadmaps, stakeholder briefs and delivery oversight.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="consultancy-services advisory-details">
        <h2>Advisory Package</h2>
        <div className="services-list">
          <div className="service-item left">
            <div className="service-content">
              <h3>Feasibility & Market Assessment</h3>
              <p>Comprehensive study combining market data, stakeholder needs and commercial viability analysis.</p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L3 7v7c0 5 5 9 9 9s9-4 9-9V7l-9-5z" opacity=".2"/><path d="M12 2l9 5v7c0 5-5 9-9 9S3 19 3 14V7l9-5zm0 2.2L6.6 7 12 10.8 17.4 7 12 4.2zM8 13h8v2H8v-2z"/></svg>
            </div>
          </div>

          <div className="service-item right">
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zM13 21h8v-10h-8v10zm0-18v6h8V3h-8z" opacity=".2"/><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zM13 21h8v-10h-8v10zm0-18v6h8V3h-8z"/></svg>
            </div>
            <div className="service-content">
              <h3>Project Roadmap & Governance</h3>
              <p>Clear deliverables, milestones and governance structures so your team and stakeholders stay aligned.</p>
            </div>
          </div>

          <div className="service-item left">
            <div className="service-content">
              <h3>Technical Coordination</h3>
              <p>Technical reviews, vendor shortlists and architecture guidance to reduce delivery risk.</p>
            </div>
            <div className="service-icon-wrapper">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="#16c784" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l4 8 8 .5-6 5 2.5 8L12 18l-10.5 6L4 15 0 10.5 8 10.5 12 2z" opacity=".18"/><path d="M12 2l4 8 8 .5-6 5 2.5 8L12 18l-10.5 6L4 15 0 10.5 8 10.5 12 2z"/></svg>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
